import store from '@/store';

export default function translate(key) {
  const messages = store?.state?.bootstrap?.messages || {};
  return messages[key] || key;
}
